import { defineMessages } from 'react-intl';

export default defineMessages({
  included: {
    id: 'common.prices.included',
    defaultMessage: 'Included',
  },
});
